var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-4" }, [
    _c("div", { staticClass: "right-inner-addon" }, [
      _c("i", { staticClass: "fa fa-search" }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        staticClass: "form-control search-lists",
        attrs: {
          id: "search",
          type: "search",
          placeholder: _vm.$t("lists.searchList"),
          autocomplete: "off",
        },
        domProps: { value: _vm.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "d-none", attrs: { for: "search" } }, [
        _vm._v(_vm._s(_vm.$t("global.words.search"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }